import { Navigate, type RouteObject } from "react-router-dom";
import WsgContactStaff from "../pages/SiteUpdates/WsgContactStaff";
import StaffContent from "../pages/Content/StaffContent";
import ManageArticle from "../pages/Content/ManageArticle";
import EditArticle from "../pages/Content/EditArticle";
import Preview from "../pages/Content/Preview";
import ViewMode from "../pages/ProfileViewMode/ViewMode";
import SuccessStoriesContent from "../pages/Content/SucessStoriesContent";
import MemberReportsContent from "../pages/Content/MemberReportsContent";
import ManageFirmList from "../pages/ManageFirm/ManageFirmList";
import ManageFirmLayout from "../pages/ManageFirm/ManageFirmLayout";
import ManageFirmGeneralTab from "../pages/ManageFirm/GeneralTab";
import ViewNotes from "../pages/ManageFirm/GeneralTab/Notes/ViewNotes";
import ManageDataAdmin from "../pages/ManageFirm/GeneralTab/DataAdmin/ManageDataAdmin";
import ManageAddNote from "../pages/ManageFirm/GeneralTab/Notes/AddNote";
import ManageFirmContact from "../pages/ManageFirm/GeneralTab/FirmContact/ManageFirmContact";
import ManageMainContact from "../pages/ManageFirm/GeneralTab/MemberMainContact/ManageMainContacts";
import ManageFirmContent from "../pages/Content/ManageFirmContent";
import ManageFirmLegacyIFrame from "../pages/ManageFirm/ManageFirmLegacyIFrame";
import ModifyFirmProfile from "../pages/ManageFirm/ModifyProfile";
import ModifyMainOffices from "../pages/ManageFirm/ModifyOffices/MainOffices";
import ModifyAdditionalOffices from "../pages/ManageFirm/ModifyOffices/AdditionalOffices";
import ManageFirmProfile from "../pages/ManageFirm/Profile";
import Professionals, {
  professionalsLoader,
} from "../pages/ManageFirm/Professionals/Professionals";
import AddProfessional, {
  addProfessionalEditLoader,
} from "../components/Organismos/Person/AddProfessional";
import ProfessionalUserLogs from "../pages/ManageFirm/Professionals/ProfessionalUserLogs";
import AopManagement from "../pages/ManageFirm/AopManagement/AopManagement";
import AopProfessionalsPage from "../pages/ManageFirm/AopManagement/Professionals";
import AddAOPs from "../pages/ManageFirm/AopManagement/AddAOPs";
import ManageFirmPracticeHeadsTab from "../pages/ManageFirm/PracticeHeads";
import ManageFirmPracticeHeadsEditTab from "../pages/ManageFirm/PracticeHeads/PracticeHeadsEdit";
import ActivityLog from "../pages/SEO/ActivityLog";
import ActivityLogDetails from "../pages/SEO/ActivityLogDetails";
import AOPMapping from "../pages/SEO/AOPMapping";
import AOPMappingForm from "../pages/SEO/AOPMappingForm";
import AopRankingModule from "../pages/AopRanking/AopRankingModule";
import AddDataAdmin from "../pages/Catalogs/CRUD/AddDataAdmin";
import AddAOPRanking from "../pages/Catalogs/CRUD/AddAopRanking";
import AddFirm from "../pages/Catalogs/CRUD/AddFirm";
import CreateFirmWithOffice from "../pages/ManageFirm/CreateFirm/CreateFirmWithOffice";
import AddContent from "../pages/Catalogs/CRUD/AddContent";
import StaffEventDetails from "../pages/EventsPage/StaffEventDetails";
import EventList from "../pages/Events/EventList";
import EventAttendees from "../pages/Events/EventAttendees";
import EmailDesign from "../pages/EmailTemplates/EmailDesign";
import EmailTemplateLogsPage from "../pages/EmailTemplates/EmailTemplateLogsPage";
import EmailStatsPage from "../pages/EmailTemplates/EmailStats/EmailStatsPage";
import EmailStatsDetailPage from "../pages/EmailTemplates/EmailStats/EmailStatsDetailPage";
import SeeTemplates from "../pages/EmailTemplates/SeeTemplates";
import AddEnvelope from "../pages/EmailTemplates/AddEnvelope";
import BeefreeEditorPage from "../pages/EmailTemplates/BeefreeEditorPage";
import HtmlEditorPage from "../pages/EmailTemplates/HtmlEditorPage";
import { EmailTemplatesBreadcrumbActions } from "../components/Layout/Breadcrumb/BreadcrumbRightActions";
import EditParticipant from "../pages/Events/EditParticipant";
import GeneralSettings2 from "../pages/EventsPage/AddEvent";
import InputComponentsTest from "../pages/InputComponentsTest/InputComponentsTest";
import Attendees from "../pages/Events/Attendees";
import Company from "../pages/Catalogs/Company";
import AddCompanyCatalog from "../pages/Catalogs/CRUD/AddCompany";
import GuestSpeaker from "../pages/Catalogs/GuestSpeaker";
import AddGuestSpeakerCatalog from "../pages/Catalogs/CRUD/AddGuestSpeaker";
import SendEmail from "../pages/SendEmail/SendEmail";
import UnsubscribedList from "../pages/EmailTemplates/UnsubscribedList";
import StaffEmailSubscriptionsPage from "../pages/EmailTemplates/StaffEmailSubscriptionsPage";
import PendingScheduledEmails from "../pages/SendEmail/PendingScheduledEmails";
import { ProfileStaffOverviewPage } from "../pages/ProfileEditMode/ProfileMemberOverviewPage";
import Accounting from "../pages/Accounting/Accounting";
import AccountingFirmDetail from "../pages/Accounting/AccountingFirmDetail";
import AccountingOfficeBalanceLedger from "../pages/Accounting/AccountingOfficeBalanceLedger";
import InvoicesList from "../pages/Accounting/InvoicesList";
import IntegratorEngine from "../pages/IntegratorEngine";
import EditIntegratorFirm from "../pages/IntegratorEngine/firms/edit";
import ListIntegratorRunLogs from "../pages/IntegratorEngine/runLogs/index";
import ViewIntegratorRunLog from "../pages/IntegratorEngine/runLogs/view";
import ManageIntegratorProfessionals from "../pages/IntegratorEngine/professionals";
import HelpCenterCategoryEditPage from "../pages/HelpCenter/HelpCenterCategoryEditPage";

export const StaffRoutes: RouteObject[] = [
  {
    path: "/site-updates/contacts",
    element: <WsgContactStaff />,
  },
  // The staff Help Center itself is `/help-center?portal=staff`, which cannot be a route entry
  // here because React Router ignores the query string; it is declared in MemberRoutes and gated
  // by permission. Only the manage screens have staff-only paths.
  {
    path: "/help-center/manage",
    element: <Navigate to="/help-center" replace />,
  },
  {
    path: "/help-center/manage/:audience",
    element: <Navigate to="/help-center" replace />,
  },
  {
    path: "/help-center/manage/:audience/:sectionId",
    element: <HelpCenterCategoryEditPage />,
  },
  {
    path: "/content",
    element: (
      <StaffContent
        breadcrumb={{
          prevPage: "Home",
          currentPage: "Content",
        }}
      />
    ),
  },
  {
    path: "/wsg-success-stories",
    element: (
      <SuccessStoriesContent
        breadcrumb={{
          prevPage: "Home",
          currentPage: "Content",
        }}
        persistentFilter={{
          contentType: {
            value: "successStory",
            comparisonType: "EQUAL",
          },
        }}
      />
    ),
  },
  {
    path: "/wsg-success-stories/create",
    element: <AddContent mode="add" redirectURL="/wsg-success-stories" />,
  },
  {
    path: "/wsg-success-stories/Manage/:id",
    element: <AddContent mode="edit" redirectURL="/wsg-success-stories" />,
  },
  // RWSG2-93 - Temporary removal (until WSG content is clarified)
  // {
  //   path: "/wsg-content",
  //   element: (
  //     <WSGContent
  //       breadcrumb={{
  //         prevPage: "Home",
  //         currentPage: "WSG Content",
  //       }}
  //       persistentFilter={{
  //         memberFirms: {
  //           value: "ee153da4-bbf0-4c29-80cb-29a05905ae2c",
  //           comparisonType: "EQUAL",
  //         },
  //       }}
  //     />
  //   ),
  // },
  {
    path: "/member-reports",
    element: (
      <MemberReportsContent
        breadcrumb={{
          prevPage: "Home",
          currentPage: "Content",
        }}
        persistentFilter={{
          contentType: {
            value: "memberReport",
            comparisonType: "EQUAL",
          },
        }}
      />
    ),
  },
  {
    path: "/content/manage/:id",
    element: <ManageArticle mode="edit" />,
  },
  {
    path: "/content/edit/:id",
    element: <EditArticle mode="edit" />,
  },
  {
    path: "/content/create",
    element: <EditArticle mode="add" />,
  },
  {
    path: "/Content/Preview",
    element: (
      <Preview
        canComment={true}
        showComments={true}
        canEdit={true}
        breadcrumb={{
          prevPage: "New Article",
          currentPage: "Preview",
        }}
      />
    ),
  },
  {
    path: "/ManageFirm",
    element: <ManageFirmLayout />,
    children: [
      { index: true, element: <ManageFirmList /> },
      { path: "Create", element: <CreateFirmWithOffice /> },
      { path: "create", element: <Navigate to="/ManageFirm/Create" replace /> },
      { path: "Create2", element: <Navigate to="/ManageFirm/Create" replace /> },
      { path: "legacy-creation", element: <AddFirm mode="add" /> },
      {
        path: "GeneralTab/:id",
        element: <ManageFirmGeneralTab />,
      },
      { path: "GeneralTab/:id/Notes", element: <ViewNotes /> },
      {
        path: "GeneralTab/:id/DataAdmin",
        element: <ManageDataAdmin />,
      },
      {
        path: "GeneralTab/:id/Notes/Create",
        element: <ManageAddNote mode="add" />,
      },
      {
        path: "GeneralTab/:id/Notes/Edit/:id",
        element: <ManageAddNote mode="edit" />,
      },
      {
        path: "GeneralTab/:id/FirmContact",
        element: <ManageFirmContact />,
      },
      {
        path: "GeneralTab/:id/MemberMainContact",
        element: <ManageMainContact />,
      },
      {
        path: "Content/Create",
        element: <EditArticle mode="add" disabledFirm />,
      },
      {
        path: "Content/Manage/:id",
        element: <ManageArticle mode="edit" disabledFirm />,
      },
      {
        path: "Content/Edit/:id",
        element: <EditArticle mode="edit" disabledFirm />,
      },
      { path: "Content/:id", element: <ManageFirmContent /> },
      { path: "Dashboard/:id", element: <ManageFirmLegacyIFrame /> },
      { path: "Referrals/:id", element: <ManageFirmLegacyIFrame /> },
      {
        path: "GroupParticipants/:id",
        element: <ManageFirmLegacyIFrame />,
      },
      { path: "Events/:id", element: <ManageFirmLegacyIFrame /> },
      {
        path: "Profile/modify/main/:id",
        element: <ModifyMainOffices />,
      },
      {
        path: "Profile/modify/additional/:id",
        element: <ModifyAdditionalOffices />,
      },
      { path: "Profile/modify/:id", element: <ModifyFirmProfile /> },
      {
        path: "Profile/:id/article",
        element: (
          <Preview
            breadcrumb={{
              prevPage: "Manage Firm/ Profile",
              currentPage: "Article",
            }}
            hideModal
          />
        ),
      },
      {
        path: "Profile/:id/press",
        element: (
          <Preview
            breadcrumb={{
              prevPage: "Manage Firm/ Profile",
              currentPage: "Article",
            }}
            hideModal
          />
        ),
      },
      {
        path: "Profile/:id/guide",
        element: (
          <Preview
            breadcrumb={{
              prevPage: "Manage Firm/ Profile",
              currentPage: "Article",
            }}
            hideModal
          />
        ),
      },
      { path: "Profile/:id", element: <ManageFirmProfile /> },
      {
        path: "Professionals/:id/Attorney/:generatedId",
        element: <ViewMode editmode />,
      },
      {
        path: "Professionals/:id/Logs/:userId",
        element: <ProfessionalUserLogs />,
      },
      { path: "Professionals/:id/Logs", element: <ProfessionalUserLogs /> },
      {
        path: "Professionals/:id/DataAdmin",
        element: <ManageDataAdmin />,
      },
      {
        path: "Professionals/:id/Create",
        element: <AddProfessional mode="add" />,
      },
      {
        path: "Professionals/:id/Edit/:generatedId",
        element: <AddProfessional mode="edit" />,
        loader: addProfessionalEditLoader,
      },
      {
        path: "Professionals/:id",
        element: <Professionals />,
        loader: professionalsLoader,
      },
      {
        path: "DataAdmin/Create",
        element: <AddDataAdmin mode="add" />,
      },
      { path: "aopManagement/:id", element: <AopManagement /> },
      {
        path: "aopManagement/professionals/:id",
        element: <AopProfessionalsPage />,
      },
      {
        path: "PracticeHeads/:id/Edit/:id",
        element: <ManageFirmPracticeHeadsEditTab />,
      },
      {
        path: "PracticeHeads/:id",
        element: <ManageFirmPracticeHeadsTab />,
      },
    ],
  },
  {
    path: "/manageFirm/aopManagement/update",
    element: <AddAOPs mode="add" />,
  },
  {
    path: "/ActivityLog",
    element: <ActivityLog />,
  },
  {
    path: "/ActivityLog/Details/:id",
    element: <ActivityLogDetails />,
  },
  {
    path: "/integrator-engine",
    element: <Navigate to="/integrator-engine/firms" replace />,
  },
  {
    path: "/integrator-engine/firms",
    element: <IntegratorEngine />,
  },
  {
    path: "/integrator-engine/firms/:id",
    element: <EditIntegratorFirm />,
  },
  {
    path: "/integrator-engine/run-logs",
    element: <ListIntegratorRunLogs />,
  },
  {
    path: "/integrator-engine/run-logs/:runLogId",
    element: <ViewIntegratorRunLog />,
  },
  {
    path: "/integrator-engine/professionals",
    element: <Navigate to="/integrator-engine/firms" replace />,
  },
  {
    path: "/integrator-engine/professionals/:firmId",
    element: <ManageIntegratorProfessionals />,
  },
  {
    path: "/AOP",
    element: <AOPMapping />,
  },
  {
    path: "/AOP/create",
    element: <AOPMappingForm />,
  },
  {
    path: "/AOP/edit/:id",
    element: <AOPMappingForm />,
  },
  {
    path: "/AOPRanking",
    element: <AopRankingModule />,
  },
  {
    path: "/AOPRanking/edit/:id",
    element: <AddAOPRanking mode="edit" />,
  },
  {
    path: "/attendees-registrations",
    element: <Attendees />,
  },
  {
    path: "/accounting",
    element: <Accounting />,
  },
  {
    path: "/accounting/invoices",
    element: <InvoicesList />,
  },
  {
    path: "/accounting/:id/balance",
    element: <AccountingOfficeBalanceLedger />,
  },
  {
    path: "/accounting/:id",
    element: <AccountingFirmDetail />,
  },
  {
    path: "/events-staff/:id",
    element: <StaffEventDetails />,
  },
  {
    path: "/events-staff",
    element: <EventList />,
  },
  {
    path: "/email-design",
    element: <EmailDesign />,
    handle: { breadcrumbRightActions: EmailTemplatesBreadcrumbActions },
  },
  {
    path: "/email-design/add",
    element: <AddEnvelope />,
  },
  {
    path: "/email-design/:id/edit-envelope",
    element: <AddEnvelope />,
  },
  {
    path: "/email-design/:id/edit",
    element: <BeefreeEditorPage />,
  },
  {
    path: "/email-design/:id/edit-html",
    element: <HtmlEditorPage />,
  },
  {
    path: "/email-design/:templateId/logs",
    element: <EmailTemplateLogsPage />,
  },
  {
    path: "/email-stats",
    element: <EmailStatsPage />,
  },
  {
    path: "/email-stats/:id",
    element: <EmailStatsDetailPage />,
  },
  {
    path: "/email-design/:id",
    element: <SeeTemplates />,
  },
  {
    path: "/events-staff/:eventId/attendees",
    element: <EventAttendees />,
  },
  {
    path: "/events-staff/:eventId/unpaids",
    element: <Attendees />,
  },
  {
    path: "/events-staff/:eventId/attendees/Create",
    element: <EditParticipant />,
  },
  {
    path: "/events-staff/:eventId/attendees/Edit/:registrationId",
    element: <EditParticipant />,
  },
  {
    path: "/events-staff/Create",
    element: <GeneralSettings2 />,
  },
  {
    path: "/events-staff/Edit/:id",
    element: <GeneralSettings2 />,
  },
  {
    path: "/catalogs/company",
    element: <Company />,
  },
  {
    path: "/catalogs/company/create",
    element: <AddCompanyCatalog mode="add" />,
  },
  {
    path: "/catalogs/company/edit/:id",
    element: <AddCompanyCatalog mode="edit" />,
  },
  {
    path: "/catalogs/guestspeaker",
    element: <GuestSpeaker />,
  },
  {
    path: "/catalogs/guestspeaker/create",
    element: <AddGuestSpeakerCatalog mode="add" />,
  },
  {
    path: "/catalogs/guestspeaker/edit/:id",
    element: <AddGuestSpeakerCatalog mode="edit" />,
  },
  {
    path: "/send-email",
    element: <SendEmail />,
  },
  {
    path: "/unsubscribed-list",
    element: <UnsubscribedList />,
  },
  {
    path: "/unsubscribed-list/:personId",
    element: <StaffEmailSubscriptionsPage />,
  },
  {
    path: "/send-email/scheduled-emails",
    element: <PendingScheduledEmails />,
  },
  {
    path: "/pending-scheduled-emails",
    element: <PendingScheduledEmails />,
  }, {
    path: "/staff/profile/:customPath/:generatedId",
    element: <ProfileStaffOverviewPage />,
  },
  ...(process.env.REACT_APP_ENVIRONMENT !== "prod"
    ? [
      {
        path: "/staff/test-input-components",
        element: <InputComponentsTest />,
      },
    ]
    : []),
];
